import React from 'react';

import { Tag, Tooltip, Typography } from 'antd';

import type ICoProducer from 'interfaces/ICoProducer';

type PartnerStatusConfig = {
  label: string;
  color: 'success' | 'processing' | 'warning' | 'error';
  tip: string;
};

const getPartnerStatus = (cop: ICoProducer): PartnerStatusConfig => {
  if (cop.pending && cop.action === 'remove') {
    return {
      label: 'Parceiro será removido',
      color: 'error',
      tip: 'Parceiro será removido dos parceiros do produto na nova configuração'
    };
  }

  if (!cop.new && cop.edited) {
    return {
      label: 'Parceiro será modificado',
      color: 'warning',
      tip: 'Parceiro será modificado na nova configuração'
    };
  }

  if (cop.new || !cop.customer_id) {
    return {
      label: 'Novo',
      color: 'processing',
      tip: 'Novo parceiro que será adicionado a uma nova configuração de parceiros'
    };
  }

  return {
    label: 'Ativo',
    color: 'success',
    tip: 'Parceiro está ativo no produto'
  };
};

const getApprobationStatus = (status: string) => {
  if (status === 'Aprovado') {
    return {
      color: 'success' as const,
      tip: 'Parceiro aprovou modificação/remoção'
    };
  }

  if (status === 'Reprovado') {
    return {
      color: 'error' as const,
      tip: 'Parceiro recusou modificação/remoção'
    };
  }

  return {
    color: 'processing' as const,
    tip: 'Aguardando moderação do parceiro'
  };
};

export const PartnerStatus = ({ cop }: { cop: ICoProducer }) => {
  if (cop.pending && cop.action !== 'remove') return null;

  const { label, color, tip } = getPartnerStatus(cop);

  return (
    <Tooltip title={tip} placement='top'>
      <Tag color={color}>{label}</Tag>
    </Tooltip>
  );
};

export const ApprobationStatus = ({ cop }: { cop: ICoProducer }) => {
  const { color, tip } = getApprobationStatus(cop.status);

  return (
    <Tooltip title={tip} placement='top'>
      <Tag color={color}>{cop.status}</Tag>
    </Tooltip>
  );
};
